import { Component } from "react"
import PropTypes from "prop-types"

import { findDefinitionBySlug } from "partners/components/shared/stencilable_field_types"

import "./dynamic_applet.scss"

class StepField extends Component {
  render() {
    const { step_type, field_type_definition_slug } = this.props
    let ftd
    let fragment

    if (/dropdown|checkbox/.test(field_type_definition_slug)) {
      fragment = `#field-options`
    } else if (step_type == "action") {
      fragment = "#run-an-action"
      ftd = findDefinitionBySlug(field_type_definition_slug)
    }

    return (
      <div styleName="field">
        <div>
          <label styleName="label">
            <span>{this.props.label}</span>(
            {this.props.required ? "Required" : "Optional"}) [slug:{" "}
            {this.props.name}]
          </label>
        </div>

        <div styleName="input">
          <input
            type="text"
            name={this.props.name}
            value={this.props.value}
            autoComplete="off"
            disabled
          />
        </div>

        <div styleName="note">
          {this.props.helper_text && (
            <span
              styleName="text"
              dangerouslySetInnerHTML={{ __html: this.props.helper_text }}
            />
          )}
          {this.props.step_type === "action" &&
            ftd &&
            !ftd.value.includes("dropdown") && (
              <span styleName="text spacing">
                [Action field type:{" "}
                {`${ftd.group} - ${ftd.short_name || ftd.name}`}]
              </span>
            )}
          {fragment && (
            <a
              href={`${this.props.docs_url}${fragment}`}
              target="_blank"
              rel="noopener noreferrer"
              styleName="spacing"
            >
              View documentation
            </a>
          )}
        </div>
      </div>
    )
  }
}

StepField.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  field_type_definition_slug: PropTypes.string.isRequired,
  required: PropTypes.bool.isRequired,
  helper_text: PropTypes.string,
  step_type: PropTypes.string.isRequired,
  docs_url: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
}

export default StepField
